/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_P1Inputs */

const en_guide_json_rest_api_s5_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow these conventions when designing or consuming JSON APIs:`)
};

const ko_guide_json_rest_api_s5_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON API를 설계하거나 사용할 때 다음 규칙을 따르세요:`)
};

const ja_guide_json_rest_api_s5_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON APIの設計または利用時には、以下の規約に従ってください：`)
};

/**
* | output |
* | --- |
* | "Follow these conventions when designing or consuming JSON APIs:" |
*
* @param {Guide_Json_Rest_Api_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_p1(inputs)
	return ja_guide_json_rest_api_s5_p1(inputs)
});